import './services-card-1.sass';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import image14 from '../../assets/images/image14.png';
import { Trans } from 'react-i18next';

function Services_card_1() {
  return (
    <Container fluid className="services-card1-container">
      <Row className="g-0">
        <Col md={5} className="left-col-card1">
          <p className="small-title-card1"><Trans i18nKey="small_title_card1"/></p>
          <h1 className="big-title-card1"><Trans i18nKey="big_title_card1"/></h1>
          <Button className="button-explore-card1"><Trans i18nKey="button_explore_card1"/></Button>
        </Col>
        <Col md={7} className="right-col-card1">
          <Image src={image14} alt="" fluid />
        </Col>
      </Row>
    </Container>
  );
}

export { Services_card_1 };
